import { Component, computed, inject } from '@angular/core';
import {TitleAyudaComponent} from '../../../../shared/components/title-ayuda-component/title-ayuda-component';
import { ThemeService } from '@/app/core/services/theme/theme.service';


@Component({
  selector: 'app-politica-component',
  standalone: true,
  imports: [TitleAyudaComponent],
  templateUrl: './politica-component.html',
  styleUrl: './politica-component.scss',
})
export class PoliticaComponent {
  private themeService = inject(ThemeService);

  protected pageTitle = 'Política de privacidad';
  protected themeContent = this.themeService.themeContent;
  protected politicComonent = computed(() => this.themeContent()?.helpComponent?.policiesSection); 
  

}
